<template>
	
  <div class="home">
	 <Bar />
	 <div class="jin" v-if="jin">
		 当前位置是China.建议前往中国站？<div class="but"><a href="http://cn.fmhd.209.qiyundongli.cn/">前往</a></div><div class="but but2" @click="jin=false">不用</div>
	 </div>
   <div class="home-ct">
<div class="login">
	<div class="login-r1">
	<div class="re-tit">
		<h4>LOGIN</h4>
		
		<p>In order to increase the shopping experience, the online shopping mall platform has been strengthened.</p>
	</div>

	<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="top" class="demo-ruleForm" size="mini">
	
			
	  <el-form-item label="Email" prop="email">
	    <el-input v-model="ruleForm.email"></el-input>
	  </el-form-item>

	  <el-form-item label="Password" prop="password">
	    <el-input v-model="ruleForm.password" show-password></el-input>
	  </el-form-item>
	<router-link to="/repa">Forgot your password?</router-link>
	<div class="h-button" @click="submitForm('ruleForm')">SIGN IN</div>
	  </el-form-item>
	</el-form>
	</div>
	<div class="login-r2">
		
		
		<div class="re-tit login-r3">
			<h4>CREATE ACCOUNT</h4>
			
			<p>With more ways to unlock exciting perks, this is your all access pass to exclusive rewards. </p>
				<div class="h-button"><router-link to="register">CREATE ACCOUNT</router-link></div>
		</div>
	</div>
	<div class="clear"></div>
</div>
   </div>
   <Sim />
   <Place />
    </div>
</template>
<script>

import Bar from '@/components/bar/bar'
import Place from '@/components/place/place'
import Sim from '@/components/sim/sim'
import { location } from "../../utils/Location";
export default {
  components: {

	Bar,Place,Sim
  },
  data() {
    return {
			jin:false,
            ruleForm: {
				email:'',
				password:''
			
                  },
				  
                  rules: {
					
					  email: [
					    { required: true, message: 'Please fill in email', trigger: 'blur' },
				],password: [
					    { required: true, message: 'Please fill in password', trigger: 'blur' },
				]
                 
                  },province:["陕西省","甘肃省","青海省","宁夏回族自治区","新疆维吾尔自治区","北京市","天津市","上海市","重庆市","河北省","山西省","辽宁省","吉林省","黑龙江省","江苏省","浙江省","安徽省","福建省","江西省","山东省","河南省","湖北省","湖南省","广东省","海南省","四川省","贵州省","云南省","台湾省","内蒙古自治区","广西壮族自治区","西藏自治区","香港特别行政区","澳门特别行政区"]

          };
  },  mounted() {
	  this.getLocation(); 
	  this.id = this.$route.query.id

		this.sandMate();
		this.sandCase();
		},methods: {
			getLocation() {
			
			      let _that = this;
			
			      let geolocation = location.initMap("map-container"); 
			
			      AMap.event.addListener(geolocation, "complete", result => {
				this.province.forEach((item,index)=>{
					if(result.addressComponent.province==item){
						this.jin=true
					}
				})
		
			
			      });
			
			    },
			
		 submitForm(formName) {
			
			      
		        this.$refs[formName].validate((valid) => {
		          if (valid) {
		         this.$axios({
		           method: "post",
		           url: "service.php?action=users_emailLogin",
		           data: this.ruleForm,  
		         }).then((res) => {
		         	let data=res.data;
		         			
		         	if(data.code==1){
						
						localStorage.setItem("user", JSON.stringify(data.data));
			
		     this.$alert(data.message, 'Prompt', {
		              confirmButtonText: 'Determine',
		              callback: action => {
		              this.$router.push({ path: "/" });	
		              }
		            });
		         		
		         	}else{  
						this.$message.error(data.message);
						      
					}
		          
		         });
				 
				 
		          } else {
		           
		            return false;
		          }
		        });
		      },
		      resetForm(formName) {
		        this.$refs[formName].resetFields();
		      }
		}
};
</script>
<style lang="scss" scoped>
	
	.h-button{
			text-align: center;
			cursor: pointer;
			width: 185px;
			padding: 0 50px;
			height: 50px;
			line-height: 50px;
			background: #000;
			color: #FFFFFF;
			margin-top: 30px;
		
		}
		.h-button:hover{
			background-color: #333333;
		}
	.login{
		padding: 20px 0;
		.re-tit{
			line-height: 50px;
			font-size: 14px;
			h4{
				font-size: 26px;
			}
			margin-bottom: 20px;
		}
	}	
.login-r1{
	width:500px;
	float: left;
	padding: 50px;
	border-right: 1px dotted #000000;
}
.login-r2{
	width:490px;

	padding: 50px;
	float: left;

}
.jin{
	display: flex;
	color: #ffffff;
	height: 41px;
	background: #050505;
	align-items: center;
	justify-content: center;
	.but{
		background: url(../../assets/but1.png);
		width: 53px;
		height: 29px;
		text-align: center;
		line-height: 29px;
		margin-left: 20px;
		a{
			color: #ffffff;
		}
	}
	.but2{
		color: #050505;
		background: url(../../assets/but22.png);
	}
}
</style>